import {RootType} from "./reducers";

export const getUserConnected = (store: RootType) => store.userReducers.user
